import React, { useEffect, useState } from "react";
/**
 * Components and layouts...
 */
import { Outlet } from "react-router-dom";

const ShowGenre = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default ShowGenre;
